import ActivityLogic from './ActivityLogic'
import type ChallengeBucket from '../model/ChallengeBucket'

/** Progress keyed by challenge bucket id. */
export type BucketBreakdown = Record<string, number>

/** Named view for display (Bike, Run/Walk, Workout, …). */
export type NamedBucketBreakdown = Record<string, number>

export function createEmptyBucketBreakdown(buckets: ChallengeBucket[]): BucketBreakdown {
  return Object.fromEntries(buckets.map((bucket) => [bucket.id, 0]))
}

export function toNamedBreakdown(
  buckets: ChallengeBucket[],
  breakdown: BucketBreakdown,
): NamedBucketBreakdown {
  const named: NamedBucketBreakdown = {}
  for (const bucket of buckets) {
    named[bucket.name] = breakdown[bucket.id] ?? 0
  }
  return named
}

export function getBucketBreakdownByActivityId(
  activityBreakdownByActivityId: Record<string, number>,
  activities: { id: string; bucketID?: string | null; challengeID?: string }[],
  buckets: ChallengeBucket[],
): BucketBreakdown {
  const breakdown = createEmptyBucketBreakdown(buckets)
  const activityById = new Map(activities.map((activity) => [activity.id, activity]))

  for (const [activityId, amount] of Object.entries(activityBreakdownByActivityId)) {
    const activity = activityById.get(activityId)
    const bucket = buckets.find((candidate) => activity && ActivityLogic.activityFeedsBucket(activity, candidate))
    if (!bucket) continue
    breakdown[bucket.id] = (breakdown[bucket.id] ?? 0) + amount
  }

  return breakdown
}

export function findBucket(
  buckets: ChallengeBucket[],
  bucketID: string,
): ChallengeBucket | undefined {
  return buckets.find((bucket) => bucket.id === bucketID)
}

export function bucketDisplayLabel(bucket: ChallengeBucket): string {
  return bucket.name.replace('/', ' / ')
}
